export const PERSONAL_DATA = {
  MODIFY: "تعديل البيانات الشخصية",
};

export const FORM = {
  NAME: "الإسم",
  MOBILE_NUMBER: "رقم الجوال",
};

export const BUTTON = {
  SAVE_EDIT: "حفظ التعديلات",
};
